import { axiosClient } from "@/shared/api/axios-client";
import type { TipoDocumentoAdicional } from "@/lib/types";

export interface CrearTipoDocumentoInput {
  nombre: string;
}

export interface EditarTipoDocumentoInput {
  nombre: string;
  activo: boolean;
}

export interface ListarTiposDocumentoParams {
  busqueda?: string;
  page?: number;
  pageSize?: number;
}

/** Envelope paginado del backend + conteos del catálogo completo para el header. */
export interface PaginaTiposDocumento {
  items: TipoDocumentoAdicional[];
  total: number;
  page: number;
  pageSize: number;
  totalCatalogo: number;
  totalActivos: number;
}

export async function listarTiposDocumentoAdmin(
  params: ListarTiposDocumentoParams = {}
): Promise<PaginaTiposDocumento> {
  const { data } = await axiosClient.get<PaginaTiposDocumento>(
    "/api/admin/tipos-documento",
    { params }
  );
  return data;
}

export async function crearTipoDocumento(
  input: CrearTipoDocumentoInput
): Promise<TipoDocumentoAdicional> {
  const { data } = await axiosClient.post<TipoDocumentoAdicional>(
    "/api/admin/tipos-documento",
    input
  );
  return data;
}

export async function editarTipoDocumento(
  id: string,
  input: EditarTipoDocumentoInput
): Promise<TipoDocumentoAdicional> {
  const { data } = await axiosClient.put<TipoDocumentoAdicional>(
    `/api/admin/tipos-documento/${id}`,
    input
  );
  return data;
}

export async function eliminarTipoDocumento(id: string): Promise<void> {
  await axiosClient.delete(`/api/admin/tipos-documento/${id}`);
}
